module.exports = __webpack_public_path__ + "static/2-f5fc6baa7ecf1d8e94682768bdb104aa.jpg";